import React, {useState} from 'react';
import Translate, {t} from '../../../../../components/Translate';
import Chat from '../../../../../assets/images/chats.png';
import Cross from '../../../../../assets/images/cross.png';
import Answered from '../../../../../assets/images/call.png';
import Unanswered from '../../../../../assets/images/missed-call.png';
import Forward from '../../../../../assets/images/forward-statistics.png';
import Active from '../../../../../assets/images/ongoing.png';
import PeakHoursStatistics from "./components/bots/PeakHoursStatistics";
import OperatorWorkingHours from "./components/operators/OperatorWorkingHours";
import CategoriesStatistics from "./components/chats/CategoriesStatistics";
import StatisticsConvModal from "../../../../../components/StatisticsConvModal";
import {
    clearSelectedConversation as clearSelectedConversationFromStore,
    loadOlderMessagesRequested,
    selectConversationRequested
} from "../../../../../services/chat/action";
import {confirmActionRequested} from "../../../../../services/confirmAction/action";
import {connect} from "react-redux";
import Modal from "react-modal";
import SelectedConversationHistory, {generalStyles} from "../history/ConversationHistory";
import OperatorsTable from "./components/operators/OperatorsTable";
import config from "../../../../../config";
import {filterInputStyle, titleStyles} from "../../../../../utils/General";
import BotPlatformRequestTable from "./components/chats/BotPlatformRequestTable";
import OperatorsLoginLogoutTable from "./components/operators/OperatorsLoginLogoutTable";
import LoadingComponent from "../../../../../assets/LoadingComponent";
import BotStatistics from "./components/bots/BotStatistics";

function Statistics2(props) {
    const {
        user,
        confirmAction,
        conversation,
        clearSelectedConversationFromStore,
        selectConversation,
        company,
        loadOlderMessages,
        companyInfoList,
        categoriesStatisticsData,
        statNumbers,
        isFetchingNumbers,
        isFetchingCompanyInfo,
        peakHoursStatisticsData,
        filterPeakHoursData,
        operatorsWorkTimeData,
        whStartDate,
        whEndDate,
        setWhStartDate,
        setWhEndDate,
    } = props;

    const [activeTab, setActiveTab] = useState('requests');

    const [phPlatformSearch, setPhPlatformSearch] = useState('all');
    const [phCompanySearch, setPhCompanySearch] = useState('all');

    const showConversationHistory = (conversationDetails) => {
        selectConversation({
            id: conversationDetails.conversationId,
            companyId: conversationDetails.companyId,
            platform: conversationDetails.platform,
            userFirstName: conversationDetails.customerName,
            userThumbUrl: conversationDetails.visitorThumbUrl,
            isOperatorConversation: true,
            operatorConversationId: conversationDetails.id
        });
    };

    const showFullConversationHistory = (conversationDetails) => {
        selectConversation({
            id: conversationDetails.conversationId,
            companyId: conversationDetails.companyId,
            platform: conversationDetails.platform,
            userFirstName: conversationDetails.customerName,
            userThumbUrl: conversationDetails.visitorThumbUrl,
        });
    };

    const openTrModal = (key, filters = {}) => {
        confirmAction({
                content: (
                    <StatisticsConvModal
                        user={user}
                        confirmAction={confirmAction}
                        company={company}
                        showConversationHistory={showConversationHistory}
                        showFullConversationHistory={showFullConversationHistory}
                        header={key}
                        filters={filters}
                    />
                )
            }
        );
    };

    const closeConversationHistory = () => {
        clearSelectedConversationFromStore();
        conversation.id = null;
    };

    return (
        <div>
            <div className="tab-buttons" style={{margin: '30px 0'}}>
               {/* <button
                    className={`tab-button ${activeTab === 'bots' ? 'active' : ''}`}
                    onClick={() => setActiveTab('bots')}
                >
                    <Translate text="Bots"/>
                </button>*/}

                <button
                    className={`tab-button ${activeTab === 'requests' ? 'active' : ''}`}
                    onClick={() => setActiveTab('requests')}
                >
                    <Translate text="requestsToOperators"/>
                </button>

                <button
                    className={`tab-button ${activeTab === 'operators' ? 'active' : ''}`}
                    onClick={() => setActiveTab('operators')}
                >
                    <Translate text="operators"/>
                </button>

                <button
                    className={`tab-button ${activeTab === 'graphs' ? 'active' : ''}`}
                    onClick={() => setActiveTab('graphs')}
                >
                    <Translate text="graphs"/>
                </button>
            </div>


            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '20px',
                justifyContent: 'space-between',
                maxWidth: '95%',
                margin: '20px auto'
            }}>
                {activeTab === 'bots' && (
                    company &&
                    <BotStatistics
                        openTrModal={openTrModal}
                        company={company}
                    />
                )}
                {activeTab === 'requests' && (
                    <React.Fragment>
                        <div onClick={() => openTrModal('allRequestsToOperator')}
                             className="statistic-card statistic-card-hoverable">
                            <h2><Translate text={'allRequestsToOperator'}/></h2>
                            <img style={{marginBottom: '10px'}} width={40} height={40} src={Chat}/>
                            {isFetchingNumbers ? <LoadingComponent/>
                                :
                                <span className="count">{statNumbers.allRequests}</span>
                            }
                        </div>
                        <div onClick={() => openTrModal('todaysRequestsToOperator')}
                             className="statistic-card statistic-card-hoverable">
                            <h2><Translate text={'todaysRequestsToOperator'}/></h2>
                            <img style={{marginBottom: '10px'}} width={40} height={40} src={Chat}/>
                            {isFetchingNumbers ? <LoadingComponent/>
                                :
                                <span className="count">{statNumbers.todaysRequests}</span>
                            }
                        </div>
                        <div onClick={() => openTrModal('answeredRequestsToOperator', {unanswered: false})}
                             className="statistic-card statistic-card-hoverable">
                            <h2><Translate text={'answeredRequestsToOperator'}/></h2>
                            <img style={{marginBottom: '10px'}} width={40} height={40} src={Answered}/>
                            {isFetchingNumbers ? <LoadingComponent/>
                                :
                                <span className="count">{statNumbers.answeredRequests}</span>
                            }
                        </div>
                        <div onClick={() => openTrModal('unansweredRequestsToOperator', {unanswered: true})}
                             className="statistic-card statistic-card-hoverable">
                            <h2><Translate text={'unansweredRequestsToOperator'}/></h2>
                            <img style={{marginBottom: '10px'}} width={40} height={40} src={Unanswered}/>
                            {isFetchingNumbers ? <LoadingComponent/>
                                :
                                <span className="count">{statNumbers.unansweredRequests}</span>
                            }
                        </div>
                        <div onClick={() => openTrModal('activeRequests', {statuses: 'OPERATOR_PROCESSING'})}
                             className="statistic-card statistic-card-hoverable">
                            <h2><Translate text={'activeRequests'}/></h2>
                            <img style={{marginBottom: '10px'}} width={40} height={40} src={Active}/>
                            {isFetchingNumbers ? <LoadingComponent/>
                                :
                                <span className="count">{statNumbers.activeRequests}</span>
                            }
                        </div>
                        <div onClick={() => openTrModal('forwardedRequestsToOperator', {forwarded: true})}
                             className="statistic-card statistic-card-hoverable">
                            <h2><Translate text={'forwardedRequestsToOperator'}/></h2>
                            <img style={{marginBottom: '10px'}} width={40} height={40} src={Forward}/>
                            {isFetchingNumbers ? <LoadingComponent/>
                                :
                                <span className="count">{statNumbers.forwardedRequests}</span>
                            }
                        </div>
                        <div className="statistic-card">
                            <h2><Translate text={'forbiddenWordsReplacedCount'}/></h2>
                            <img style={{marginBottom: '10px'}} width={40} height={40} src={Cross}/>
                            {isFetchingCompanyInfo ? <LoadingComponent/>
                                :
                                <span className="count">
                                    {companyInfoList.reduce((sum, company) => sum + company.forbiddenWordsReplacedCount, 0)}
                                </span>
                            }
                        </div>
                        <div className="statistic-card">
                            <h2><Translate text={'offWorkingHoursAttemptCount'}/></h2>
                            <img style={{marginBottom: '10px'}} width={40} height={40} src={Cross}/>
                            {isFetchingCompanyInfo ? <LoadingComponent/>
                                :
                                <span className="count">
                                    {companyInfoList.reduce((sum, company) => sum + company.offWorkingHoursAttemptCount, 0)}
                                </span>
                            }
                        </div>
                        <div className="statistic-card">
                            <h2><Translate text={'blockedUserAttemptCount'}/></h2>
                            <img style={{marginBottom: '10px'}} width={40} height={40} src={Cross}/>
                            {isFetchingCompanyInfo ? <LoadingComponent/>
                                :
                                <span className="count">
                                    {companyInfoList.reduce((sum, company) => sum + company.blockedUserAttemptCount, 0)}
                                </span>
                            }
                        </div>
                        <div className="statistic-card statistic-card-full-width" >
                            <h2>
                                <Translate text="requestsByBotsAndPlatforms"/>
                            </h2>
                            {
                                company && company.tariff && company.tariff.messengers &&
                                <BotPlatformRequestTable
                                    company={company}
                                    onCellClick={openTrModal}
                                />
                            }
                        </div>
                    </React.Fragment>
                )}

                {activeTab === 'operators' && (
                    <React.Fragment>

                        <div className="statistic-card statistic-card-full-width" style={{alignItems: 'stretch'}}>
                            <h2 style={{marginBottom:'0px'}}><Translate text={'operators'}/></h2>
                            {
                                company
                                &&
                                <OperatorsTable
                                    openTrModal={openTrModal}
                                    company={company}
                                />
                            }
                        </div>

                        <div className="statistic-card statistic-card-full-width" style={{alignItems: 'stretch'}}>
                            <h2><Translate text={'operatorsWorkingTime'}/></h2>

                            <div style={{marginBottom: '55px'}}>
                                <OperatorWorkingHours
                                    whEndDate={whEndDate}
                                    whStartDate={whStartDate}
                                    user={user}
                                    setWhStartDate={setWhStartDate}
                                    setWhEndDate={setWhEndDate}
                                    operatorWorkTimeData={operatorsWorkTimeData}
                                />
                            </div>

                        </div>

                        <div className="statistic-card statistic-card-full-width">
                            <h2><Translate text={'operatorLoginLogoutStatistics'}/></h2>
                            {
                                company
                                &&
                                <OperatorsLoginLogoutTable
                                    company={company}
                                />
                            }
                        </div>

                    </React.Fragment>
                )}

                {activeTab === 'graphs' && (
                    <React.Fragment>
                        <div className="statistic-card statistic-card-full-width">
                            <h2><Translate text={'peakHoursStatistics'}/></h2>
                            <div style={{display: 'flex', gap: '10px', marginBottom: '20px'}}>
                                <select
                                    value={phCompanySearch}
                                    onChange={(e) => {
                                        setPhCompanySearch(e.target.value);
                                        filterPeakHoursData(e.target.value, phPlatformSearch)
                                    }}
                                    style={filterInputStyle}
                                >
                                    <option value="all">{t({text: 'allBots', user})}</option>
                                    {company.subs.map((c) => (
                                        <option key={c.id} value={c.id}>{c.name}</option>
                                    ))}
                                </select>
                                <select
                                    value={phPlatformSearch}
                                    onChange={(e) => {
                                        setPhPlatformSearch(e.target.value);
                                        filterPeakHoursData(phCompanySearch, e.target.value)
                                    }}
                                    style={filterInputStyle}
                                >
                                    <option value="all">{t({text: 'allPlatforms', user})}</option>
                                    {Object.entries(config.platformsMap)
                                        .filter(([key]) => key !== 'company')
                                        .map(([key, label]) => (
                                            <option key={key} value={key}>
                                                {label}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <PeakHoursStatistics data={peakHoursStatisticsData} user={user}/>
                        </div>

                        <div className="statistic-card statistic-card-full-width">
                            <h2><Translate text={'categoriesStatistics'}/></h2>
                            <CategoriesStatistics categoriesStatisticsData={categoriesStatisticsData} user={user}/>
                        </div>
                    </React.Fragment>
                )}

                <Modal
                    closeTimeoutMS={config.closeTimeoutMS}
                    style={generalStyles.modalStyles}
                    isOpen={!!conversation.id}
                    onRequestClose={closeConversationHistory}
                >
                    <SelectedConversationHistory
                        company={company}
                        tariff={company.tariff}
                        conversation={conversation}
                        user={user}
                        loadOlderMessages={loadOlderMessages}
                        closeWindow={closeConversationHistory}
                    />
                </Modal>

            </div>

        </div>
    );
}

Statistics2.propTypes = {};

const mapStateToProps = (state) => ({
    conversation: state.chat.conversation,
});

const mapDispatchToProps = (dispatch) => ({
    selectConversation: (conversation) => {
        dispatch(selectConversationRequested(conversation));
    },
    loadOlderMessages: () => {
        dispatch(loadOlderMessagesRequested());
    },
    clearSelectedConversationFromStore: () => {
        dispatch(clearSelectedConversationFromStore());
    },
    confirmAction: (obj) => (dispatch(confirmActionRequested(obj.func, obj.args, obj.onCancel, obj.onCancelArgs, obj.content))),
});

export default connect(mapStateToProps, mapDispatchToProps)(Statistics2);


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/statistics/Statistics2.jsx